import React, { Component } from 'react';
import { Button, Card, Col, Form, Input, Row, Select } from 'antd';
import CompanySearch from '@comm/companySearch';
import { BackBtn } from '@comm/BackBtn';

const { Option } = Select;
const FormItem = Form.Item;

class BaseForm extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  submit = e => {
    if (e) {
      e.preventDefault();
    }
    const { handSubmit } = this.props;
    this.props.form.validateFields((err, values) => {
      if (!err) {
        handSubmit(values);
      }
    });
  };

  handleCompanyChange = (value, option) => {
    this.props.form.setFieldsValue({
      compName: option.props.children,
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { dataInfo } = this.props;
    getFieldDecorator('compName', { initialValue: dataInfo.compName });
    const ItemLayout = {
      labelCol: { span: 8 },
      wrapperCol: { span: 12 },
    };
    return (
      <Form onSubmit={this.submit}>
        <div style={{ marginBottom: '16px' }}>
          <BackBtn />
          <Button type="primary" style={{ marginRight: 10 }} htmlType="submit">
            确认
          </Button>
        </div>
        <Card>
          <Row>
            <Col span={10}>
              <FormItem label="公司名称" {...ItemLayout}>
                {getFieldDecorator(`compUuid`, {
                  rules: [
                    {
                      required: true,
                      message: '请选择公司',
                    },
                  ],
                  initialValue: dataInfo.compUuid,
                })(
                  <CompanySearch
                    companyName={dataInfo.compName}
                    companyUuid={dataInfo.compUuid}
                    onChange={(value, option) => this.handleCompanyChange(value, option)}
                    {...this.props}
                  />,
                )}
              </FormItem>
            </Col>
            <Col span={10}>
              <FormItem label="纳税人识别号" {...ItemLayout}>
                {getFieldDecorator('taxpayerNumber', {
                  initialValue: dataInfo.taxpayerNumber,
                })(<Input placeholder="纳税人识别号" type="text" />)}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={10}>
              <FormItem label="地址" {...ItemLayout}>
                {getFieldDecorator('address', {
                  initialValue: dataInfo.address,
                })(<Input placeholder="地址" />)}
              </FormItem>
            </Col>
            <Col span={10}>
              <FormItem label="电话" {...ItemLayout}>
                {getFieldDecorator('telephone', {
                  initialValue: dataInfo.telephone,
                })(<Input placeholder="电话" type="text" />)}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={10}>
              <FormItem label="开户行" {...ItemLayout}>
                {getFieldDecorator('bankName', {
                  initialValue: dataInfo.bankName,
                })(<Input placeholder="开户行" type="text" />)}
              </FormItem>
            </Col>
            <Col span={10}>
              <FormItem label="开户帐号" {...ItemLayout}>
                {getFieldDecorator('bankBook', {
                  initialValue: dataInfo.bankBook,
                })(<Input placeholder="开户帐号" type="number" />)}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={10}>
              <FormItem label="类型" {...ItemLayout}>
                {getFieldDecorator('type', {
                  initialValue: dataInfo.type,
                })(
                  <Select defaultValue={dataInfo.type || 0}>
                    <Option value={0}>一般纳税人</Option>
                    <Option value={1}>小规模纳税人</Option>
                  </Select>,
                )}
              </FormItem>
            </Col>
          </Row>
        </Card>
      </Form>
    );
  }
}

export default Form.create()(BaseForm);



// WEBPACK FOOTER //
// ./src/components/finance/bookInfo/FormBase.js